import { withTranslation, Trans } from "next-i18next";
import { useReferralProgram } from "@hooks/use-features";
import { useCurrentUser } from "@hooks/use-current-user";
import { usePrice } from "@hooks/use-prices";
import ReferralShareLink from "@components/views/Profile/Referral/ReferralShareLink";
import redeemTypes from "@utils/constants/redeemTypes";

function FooterReferral({ t }) {
  const {
    referree_coupon: referreeCoupon,
    referrer_subscription_credit_reward: referrerRewardInCents,
  } = useReferralProgram();
  const user = useCurrentUser();
  const price = usePrice();

  const durationInMonths = parseInt(referreeCoupon?.duration_in_months, 10) || 1;

  if (!user?.referring_token) return null;

  const referreeGainText = () => {
    switch (referreeCoupon.duration) {
      case "forever":
        switch (referreeCoupon.type) {
          case redeemTypes.couponPercentOff:
            return (
              <Trans
                i18nKey="common:referral.referree_gain.percent_off_forever"
                values={{ percent: referreeCoupon.value }}
                components={[
                  <span
                    className="font-size-lg"
                    key="first"
                  />,
                ]}
              />
            );
          case redeemTypes.couponAmountOff:
            return (
              <Trans
                i18nKey="common:referral.referree_gain.amount_off_forever"
                values={{
                  amount: price(referreeCoupon.value, { withoutCents: true, withoutSpace: true }),
                }}
                components={[
                  <span
                    className="font-size-lg"
                    key="first"
                  />,
                ]}
              />
            );
        }
        break;
      case "once":
      case "repeating":
        switch (referreeCoupon.type) {
          case redeemTypes.couponPercentOff:
            return (
              <Trans
                i18nKey="common:referral.referree_gain.percent_off"
                values={{
                  percent: referreeCoupon.value,
                  count: durationInMonths,
                }}
                components={[
                  <span
                    className="font-size-lg"
                    key="first"
                  />,
                ]}
              />
            );
          case redeemTypes.couponAmountOff:
            return (
              <Trans
                i18nKey="common:referral.referree_gain.amount_off"
                values={{
                  amount: price(referreeCoupon.value, { withoutCents: true, withoutSpace: true }),
                  count: durationInMonths,
                }}
                components={[
                  <span
                    className="font-size-lg"
                    key="first"
                  />,
                ]}
              />
            );
        }
    }
  };

  return (
    <div className="bg-white p-3 text-center">
      <h5 className="mb-2">{t("common:referral.footer_title")}</h5>
      <h6 className="text-primary mb-0">
        <Trans
          i18nKey="common:referral.referrer_gain"
          values={{
            amount: price(referrerRewardInCents, { withoutCents: true, withoutSpace: true }),
          }}
          components={[
            <span
              className="font-size-lg"
              key="first"
            />,
          ]}
        />
      </h6>
      <h6 className="mb-3">{referreeGainText()}</h6>

      <div className="d-flex flex-column justify-content-center align-items-center">
        <ReferralShareLink
          trackingName="profileShareReferral"
          size="sm"
        />
      </div>
    </div>
  );
}

export default withTranslation("common")(FooterReferral);
